import { render, staticRenderFns } from "./ApiCalls.vue?vue&type=template&id=99bb553a&"
import script from "./ApiCalls.vue?vue&type=script&lang=js&"
export * from "./ApiCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99bb553a')) {
      api.createRecord('99bb553a', component.options)
    } else {
      api.reload('99bb553a', component.options)
    }
    module.hot.accept("./ApiCalls.vue?vue&type=template&id=99bb553a&", function () {
      api.rerender('99bb553a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/ApiCalls.vue"
export default component.exports